import { Component, Prop, h, Host, Watch, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'uui-select-option',
  styleUrl: 'uui-select-option.css',
  shadow: false,
  scoped: true
})
export class UuiSelectOption {
  @Prop({ reflect: true }) value: string;
  @Prop({ reflect: true }) name: string;
  @Prop({ reflect: true }) label: string;
  @Prop({ reflect: true }) disabled = false;
  @Prop({reflect: true }) checked = false;
  @Event({ bubbles: true, composed: true }) checkedChange: EventEmitter;

  @Watch("checked")
  onCheckedChange(newVal: boolean) {
    // ensure rendering has complete before triggering event as the parent element checks the the check status in the DOM
    requestAnimationFrame(() => {
      this.checkedChange.emit(newVal);
    });
  }

  render() {
    return (
      <Host>
        <li role="option">
          <uui-checkbox value={this.value} label={this.label} disabled={this.disabled} checked={this.checked} name={this.name}>
            {this.label}
          </uui-checkbox>
        </li>
      </Host>
    );
  }
}
